export const DEFAULT_ELECTRICITY_LEGEND_ITEMS = [
    { colour: '#FF0000', id: 'all' }
];

export const COLOUR_CODING_ELECTRICITY_LEGEND_ITEMS = [
    { colour: '#A07208', id: 'lv' },
    { colour: '#4B87FF', id: '6.6kv' },
    { colour: '#F70707', id: '11kv' },
    { colour: '#50B27E', id: '33kv' },
    { colour: '#9960C1', id: '132to400kv' },
    { colour: '#FF8FD1', id: 'other' }
];
